// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPhoneInfoDto } from './IPhoneInfoDto';
import {
    IPhoneInfoDtoFromJSON,
    IPhoneInfoDtoFromJSONTyped,
    IPhoneInfoDtoToJSON,
    IPhoneInfoDtoToJSONTyped,
} from './IPhoneInfoDto';
import type { IParticipantAddressInfoDto } from './IParticipantAddressInfoDto';
import {
    IParticipantAddressInfoDtoFromJSON,
    IParticipantAddressInfoDtoFromJSONTyped,
    IParticipantAddressInfoDtoToJSON,
    IParticipantAddressInfoDtoToJSONTyped,
} from './IParticipantAddressInfoDto';

/**
 * 
 * @export
 * @interface IEmployeeInfoPatchDto
 */
export interface IEmployeeInfoPatchDto {
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeInfoPatchDto
     */
    is_electronic_statement_only?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoPatchDto
     */
    employee_provided_email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeInfoPatchDto
     */
    is_employee_email_preferred?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoPatchDto
     * @deprecated
     */
    preferred_phone_type?: IEmployeeInfoPatchDtoPreferredPhoneTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoPatchDto
     * @deprecated
     */
    preferred_phone_number?: string;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeeInfoPatchDto
     */
    phone?: IPhoneInfoDto;
    /**
     * 
     * @type {number}
     * @memberof IEmployeeInfoPatchDto
     */
    citizenship_country_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeInfoPatchDto
     */
    is_sms_notification_enabled?: boolean;
    /**
     * 
     * @type {IParticipantAddressInfoDto}
     * @memberof IEmployeeInfoPatchDto
     */
    mailing_address?: IParticipantAddressInfoDto;
}

/**
* @export
* @enum {string}
*/
export enum IEmployeeInfoPatchDtoPreferredPhoneTypeEnum {
    WORK = 'WORK',
    HOME = 'HOME',
    UNKNOWN = 'UNKNOWN',
    MOBILE = 'MOBILE'
}


/**
 * Check if a given object implements the IEmployeeInfoPatchDto interface.
 */
export function instanceOfIEmployeeInfoPatchDto(value: object): value is IEmployeeInfoPatchDto {
    return true;
}

export function IEmployeeInfoPatchDtoFromJSON(json: any): IEmployeeInfoPatchDto {
    return IEmployeeInfoPatchDtoFromJSONTyped(json, false);
}

export function IEmployeeInfoPatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeInfoPatchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_electronic_statement_only': json['is_electronic_statement_only'] == null ? undefined : json['is_electronic_statement_only'],
        'employee_provided_email': json['employee_provided_email'] == null ? undefined : json['employee_provided_email'],
        'is_employee_email_preferred': json['is_employee_email_preferred'] == null ? undefined : json['is_employee_email_preferred'],
        'preferred_phone_type': json['preferred_phone_type'] == null ? undefined : json['preferred_phone_type'],
        'preferred_phone_number': json['preferred_phone_number'] == null ? undefined : json['preferred_phone_number'],
        'phone': json['phone'] == null ? undefined : IPhoneInfoDtoFromJSON(json['phone']),
        'citizenship_country_id': json['citizenship_country_id'] == null ? undefined : json['citizenship_country_id'],
        'is_sms_notification_enabled': json['is_sms_notification_enabled'] == null ? undefined : json['is_sms_notification_enabled'],
        'mailing_address': json['mailing_address'] == null ? undefined : IParticipantAddressInfoDtoFromJSON(json['mailing_address']),
    };
}

export function IEmployeeInfoPatchDtoToJSON(json: any): IEmployeeInfoPatchDto {
    return IEmployeeInfoPatchDtoToJSONTyped(json, false);
}

export function IEmployeeInfoPatchDtoToJSONTyped(value?: IEmployeeInfoPatchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_electronic_statement_only': value['is_electronic_statement_only'],
        'employee_provided_email': value['employee_provided_email'],
        'is_employee_email_preferred': value['is_employee_email_preferred'],
        'preferred_phone_type': value['preferred_phone_type'],
        'preferred_phone_number': value['preferred_phone_number'],
        'phone': IPhoneInfoDtoToJSON(value['phone']),
        'citizenship_country_id': value['citizenship_country_id'],
        'is_sms_notification_enabled': value['is_sms_notification_enabled'],
        'mailing_address': IParticipantAddressInfoDtoToJSON(value['mailing_address']),
    };
}

